import {createApi} from '@reduxjs/toolkit/query/react';

import {
    IDashboardFilterEntity,
    IDashboardEntity,
    IDashboardSettingsEntity,
    ISectionSettings,
} from 'components/personal-account/tabs/dashboards/dashboards-types';

import {axiosBaseQuery} from '../base-query';

const dashboardApiUrl = '/settings.user.dashboards';

export const DashboardAPI = createApi({
    reducerPath: 'dashboardAPI',
    baseQuery: axiosBaseQuery(),
    endpoints: build => ({
        fetchAllDashboardsSettings: build.query<IDashboardSettingsEntity[], null>({
            query: () => ({
                url: dashboardApiUrl,
            }),
        }),
        fetchAllDashboards: build.query<IDashboardEntity[], null>({
            query: () => ({
                url: `${dashboardApiUrl}/dashboards`,
            }),
        }),
        fetchAllFavoriteDashboards: build.query<IDashboardEntity[], null>({
            query: () => ({
                url: `${dashboardApiUrl}/favorites`,
            }),
        }),
        fetchAllDashboardsSelects: build.query<IDashboardFilterEntity[], null>({
            query: () => ({
                url: `${dashboardApiUrl}/filters`,
            }),
        }),
        fetchAllDashboardsSettingsPost: build.mutation<IDashboardEntity[], ISectionSettings[] | undefined>({
            query(post) {
                return {
                    url: dashboardApiUrl,
                    method: 'POST',
                    data: post,
                };
            },
        }),
        fetchAllFavoriteDashboardsPost: build.mutation<
            IDashboardSettingsEntity[],
            IDashboardSettingsEntity[] | undefined
        >({
            query(post) {
                return {
                    url: dashboardApiUrl,
                    method: 'POST',
                    data: post,
                };
            },
        }),
        fetchAllDashboardsSelectsPost: build.mutation<IDashboardFilterEntity[], IDashboardFilterEntity[] | undefined>({
            query(post) {
                return {
                    url: `${dashboardApiUrl}/filters`,
                    method: 'POST',
                    data: post,
                };
            },
        }),
    }),
});

export const {
    useFetchAllDashboardsSettingsPostMutation,
    useLazyFetchAllDashboardsSettingsQuery,
    useLazyFetchAllFavoriteDashboardsQuery,
    useLazyFetchAllDashboardsSelectsQuery,
    useLazyFetchAllDashboardsQuery,
    useFetchAllDashboardsSelectsPostMutation,
} = DashboardAPI;
